import { reactive } from "vue";

// docs: https://vuejs.org/guide/scaling-up/state-management.html#simple-state-management-with-reactivity-api
export const audioConfig = reactive({
  mimeType: "audio/mp3",
  studentMessageFileName: "audio.mp3",
});
